import { Link } from 'react-router-dom';
import { MessageCircle, Mail, Instagram, MapPin } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { siteConfig, waLink } from '../config/site';
import { Logo } from './Logo';

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="grain relative bg-navy text-ivory" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 py-20 md:grid-cols-3 md:px-8 md:py-28">
        <div>
          <Logo light />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/60">{t.footer.desc}</p>
          <p className="mt-6 font-heading text-lg italic text-gold">{siteConfig.tagline}</p>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">{t.footer.explore}</h4>
          <nav className="mt-6 flex flex-col gap-3" data-testid="footer-nav">
            <Link to="/" className="text-sm text-ivory/70 transition-colors hover:text-gold" data-testid="footer-nav-home">{t.nav.home}</Link>
            <Link to="/destinations" className="text-sm text-ivory/70 transition-colors hover:text-gold" data-testid="footer-nav-destinations">{t.nav.destinations}</Link>
            <Link to="/private-trips" className="text-sm text-ivory/70 transition-colors hover:text-gold" data-testid="footer-nav-private-trips">{t.nav.privateTrips}</Link>
            <Link to="/journal" className="text-sm text-ivory/70 transition-colors hover:text-gold" data-testid="footer-nav-journal">{t.nav.journal}</Link>
            <Link to="/plan" className="text-sm text-ivory/70 transition-colors hover:text-gold" data-testid="footer-nav-plan">{t.nav.planMyTrip}</Link>
            <Link to="/contact" className="text-sm text-ivory/70 transition-colors hover:text-gold" data-testid="footer-nav-contact">{t.nav.contact}</Link>
          </nav>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">{t.footer.contactUs}</h4>
          <div className="mt-6 flex flex-col gap-4 text-sm text-ivory/70" data-testid="footer-contact">
            <a href={waLink(t.whatsappDefault)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-whatsapp">
              <MessageCircle className="h-4 w-4 text-gold" /> {siteConfig.whatsappDisplay}
            </a>
            <a href={`mailto:${siteConfig.email}`} className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-email">
              <Mail className="h-4 w-4 text-gold" /> {siteConfig.email}
            </a>
            <a href={siteConfig.instagramUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-instagram">
              <Instagram className="h-4 w-4 text-gold" /> {siteConfig.instagramHandle}
            </a>
            <span className="flex items-start gap-3" data-testid="footer-office">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> {siteConfig.officeLocation.id}
            </span>
          </div>
        </div>
      </div>

      <div className="border-t border-ivory/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-5 py-6 text-xs text-ivory/40 md:flex-row md:items-center md:px-8">
          <span data-testid="footer-copyright">© {year} {siteConfig.brandName}. {t.footer.rights}</span>
          <span className="tracking-[0.25em] uppercase">{siteConfig.positioning.en}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
